function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM12 15.45L16.23 18L15.11 13.18L18.84 9.95L13.92 9.53L12 5L10.08 9.54L5.16 9.96L8.89 13.19L7.77 18L12 15.45Z",
  fill: "#979797"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  maskType: "alpha",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 2,
  width: 20,
  height: 20
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM12 15.45L16.23 18L15.11 13.18L18.84 9.95L13.92 9.53L12 5L10.08 9.54L5.16 9.96L8.89 13.19L7.77 18L12 15.45Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#979797"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/star.9588ffdd.svg";
export { SvgComponent as ReactComponent };